<template>
    <div id="app">
        <router-view/>
        <vue-progress-bar/>
        <be-notifications/>
        <be-scroll-top/>
    </div>
</template>

<script>
    import env from '../mixins/env';

    export default {
        mixins: [env],

        mounted() {
            if (this.isDebugMode) {
                const script = document.createElement('script');
                script.setAttribute('src', 'http://localhost:8098');
                document.head.appendChild(script);
            }
        },
    };
</script>
